import React, { useState } from "react";
// import IP from "../../../images/IP_Image.png"
import IP from "../../../images/peck2.jpg";
// import TajMahal from "../../images/TajMahal.png"
import TajMahal from "../../../images/Group 706.png";
// import "./registernow.css"
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../../API/IP";
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import CircularProgress from '@mui/material/CircularProgress';
// import Box from '@mui/material/Box';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { postRequestGlobal } from "../../../API/global";

const Test = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  // const [open, setOpen] = React.useState(false);
  const [setLoading] = useState(false);

  const [setAlertOpen] = useState(false);
  const [setAlertMessage] = useState("");
  const [setAlertSeverity] = useState("success");
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [emailError, setEmailError] = useState("");

  const handleClickShowPasswordOne = () => setShowPasswordOne((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // console.log(formData)

  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validateValues = (inputValues) => {
    let errors = {};
    if (!inputValues.username || inputValues.username.length < 10) {
      errors.username = "Email is too short";
    }
    if (!inputValues.password || inputValues.password.length < 5) {
      errors.password = "Password is too short";
    }
    return errors;
  };

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    if (name === "username") {
      await handleEmailVerify(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateValues(formData);
    setErrors(formErrors);
    const emailErrorMsg = await handleEmailVerify(formData.username);
    // console.log({ emailErrorMsg });
    if (!emailErrorMsg) {
      return;
    }

    // Check if there are any errors
    if (Object.keys(formErrors).length > 0) {
      // There are validation errors, do not submit the form
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...formData,
      };
      const response = await postRequest("login", payload);
      setFormData({
        username: "",
        password: "",
      });
      const token = response.authorization.access_token;
      localStorage.setItem("token", token);
      setAlertMessage("Login successfully");
      setAlertSeverity("success");
      setAlertOpen(true);
      // navigate('/dashboard');
      setTimeout(() => {
        navigate("/dashboard");
        setLoading(false);
      }, 1000);
      // alert('Login successfully');
    } catch (error) {
      console.error("Error: ", error);
      setErrors("Invalid username or password. Please try again.");
      setAlertMessage("Invalid username or password. Please try again.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  };
  const handleEmailVerify = async (value) => {
    let flag = true;
    let emailErrorMsg = "";
    if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
      flag = false;
      emailErrorMsg = "Invalid email format";
    } else {
      try {
        const payload = { email: value };

        const response = await postRequestGlobal("verify-email", payload);
        if (response.data === 0) {
          flag = false;
          emailErrorMsg = "Email ID does not exist";
        }
      } catch (error) {
        console.error("Error verifying email:", error);
      }
    }
    setEmailError(emailErrorMsg);
    return flag;
  };

  return (
    <>
      <div className="deshbord">
        <div className="row">
          <div className="col-md-5 coll">
            <img
              src={IP}
              className="mob-IP"
              alt="Indian Panorama"
              width="100%"
              height="100%"
            />
          </div>
          <div className="col-md-7 coll befoaffo">
            <div className="container">
              <p className="register me-3">
                Don't have account ?{" "}
                <Link to="/registration" className="register_now">
                  {" "}
                  Register Now
                </Link>
              </p>
              <h1 className="welcome">Welcome</h1>
              {/* <p className='login_with_email'>Login with Email</p> */}
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="input_field">
                  <TextField
                    variant="outlined"
                    fullWidth
                    type="email"
                    placeholder="Email ID"
                    className="input_border"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    iconstart={<EmailIcon />}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {emailError && (
                    <p className="error text-danger">{emailError}</p>
                  )}
                </div>
                <div>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="*************"
                    type={showPasswordOne ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPasswordOne}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPasswordOne ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.password ? (
                    <p className="error text-danger">
                      Please enter valid password
                    </p>
                  ) : null}
                </div>
                <p className="forget_password">
                  <Link to="/forget-password" className="register_now">
                    Forget your password?
                  </Link>
                </p>
                <div className="button">
                  <button className="login">Log in</button>
                </div>
              </form>
            </div>
            <div>
              <img
                src={TajMahal}
                className="tajmahal"
                alt="Tajmal image"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Test;
